import {axios} from '@http_client';
import cookie from 'react-cookies';
import md5 from 'md5';
import {$http} from "../helpers/http";
import {saveCookie} from "@baseHelpers/cookie";
import {httpBuildQuery, isEmpty, str_replace} from "../components/helpers/helpers";
import {getFile} from "@models/media";
import {inArray} from "@helpers/arrays";
import {$httpInSSR} from "../helpers/http_in_ssr";
import {getCacheKey} from "./cache_key";

const cacheTable = 'users';

class User {

    constructor() {
        this.id = null;
        this.first_name = null;
        this.last_name = null;
        this.email = null;
        this.mobile = null;
        this.mobile2 = null;
        this.phone1 = null;
        this.phone2 = null;
        this.phone3 = null;
        this.phone4 = null;
        this.fax = null;
        this.born_at = null;
        this.gender = null;
        this.city_id = null;
        this.city_name = null;
        this.district_id = null;
        this.district_name = null;
        this.address = null;
        this.full_address = null;
        this.work_scope = null;
        this.postal_code = null;
        this.role_id = null;
        this.role_name = null;
        this.agency_id = null;
        this.agency_name = null;
        this.agency_location = null;
        this.type = null;
        this.about_me = null;
        this.website = null;
        this.national_code = null;
        this.status = null;
        this.summary = null;
        this.avatar = null;
        this.education = null;
        this.how_introduce = null;
        this.married = false;
        this.job = null;
        this.updated_at = null;
    }

    get fullName() {
        const first_name = !isEmpty(this.first_name) ? this.first_name + ' ' : '';
        const last_name = !isEmpty(this.last_name) ? this.last_name : '';
        return first_name + last_name;
    }

    /**
     *
     * @param {object} entity
     *
     * @return {User}
     */
    static make(entity) {
        const user = new User();

        user.id = entity.id ?? null;
        user.first_name = entity.first_name ?? null;
        user.last_name = entity.last_name ?? null;
        user.email = entity.email ?? null;
        user.mobile = entity.mobile ?? null;
        user.mobile2 = entity.mobile2 ?? null;
        user.phone1 = entity.phone1 ?? null;
        user.phone2 = entity.phone2 ?? null;
        user.phone3 = entity.phone3 ?? null;
        user.phone4 = entity.phone4 ?? null;
        user.fax = entity.fax ?? null;
        user.born_at = entity.born_at ?? null;
        user.gender = entity.gender ?? null;
        user.city_id = entity.city_id ?? null;
        user.city_name = entity.city_name ?? null;
        user.district_id = entity.district_id ?? null;
        user.district_name = entity.district_name ?? null;
        user.address = entity.address ?? null;
        user.full_address = entity.full_address ?? null;
        user.agency_location = entity.agency_location ?? null;
        user.work_scope = entity.work_scope ?? null;
        user.postal_code = entity.postal_code ?? null;
        user.role_id = entity.role_id ?? null;
        user.role_name = entity.role_name ?? null;
        user.agency_name = entity.agency_name ?? null;
        user.agency_id = entity.agency_id ?? null;
        user.type = entity.type ?? null;
        user.about_me = entity.about_me ?? null;
        user.website = entity.website ?? null;
        user.national_code = entity.national_code ?? null;
        user.status = entity.status ?? null;
        user.summary = entity.summary ?? null;
        user.avatar = entity.avatar ?? null;
        user.education = entity.education ?? null;
        user.how_introduce = entity.how_introduce ?? null;
        user.married = entity.married ?? false;
        user.job = entity.job ?? null;
        user.updated_at = entity.updated_at ?? 111111;

        return user;
    }
}

export default User;

const realtorRolesName = [
    'contact',
    'realtor',
    'base',
    'gold',
    'pro',
    'independent',
    'private_representative',
    'representative',
    'vip',
    'agency_base',
    'agency_gold',
    'agency_pro',
    'agency_pro_new',
    'agency_super',
    'agency_demo',
];

const allRoleNamesExceptAdmin = [
    'pre_registered',
    'registered',
    'owner',
    'contact',
    'realtor',
    'base',
    'gold',
    'pro',
    'independent',
    'private_representative',
    'representative',
    'vip',
    'agency_base',
    'agency_gold',
    'agency_pro',
    'agency_pro_new',
    'agency_super',
    'agency_demo'
];

const normalUserRoles = [
    'pre_registered',
    'registered',
    'owner',
];

/*
* *****************************  Helpers  **********************
* */


export function getFullName(user) {
    const first_name = !isEmpty(user.first_name) ? user.first_name : '';
    const last_name = !isEmpty(user.last_name) ? ' ' + user.last_name : '';
    return first_name + last_name;
}

export function isRealtor(user) {
    const role_name = user.role_name;

    return inArray(role_name, realtorRolesName);
}

export function isNormalUser(user) {
    const role_name = user.role_name;

    return inArray(role_name, normalUserRoles);
}

export function isAgency(user) {
    const type = user.type;
    return (type === 'agency');
}

export function isAdmin(user) {
    return (!inArray(user.role_name, allRoleNamesExceptAdmin))
}

export function isContact(user) {
    return (user.role_name === 'contact');
}

export function getAvatar(user_id = null, updated_at = null) {
    if (!isEmpty(user_id)) {
        return getFile('/users/' + user_id + '/avatar.jpg' + (!isEmpty(updated_at) ? '?' + updated_at : ''));
    }

    return '/_img/default/avatar.jpg';
}

export function getRealtorProfileUrl(contactInfo) {
    const {username, realtor_city_name, realtor_district_name, realtor_slug, agency_name, fullName} = contactInfo;
    let path = '/';

    if (!isEmpty(username)) {
        path = path + username;
    } else {
        let name = fullName;
        if (isEmpty(name)) {
            name = 'مشاور';
        }

        path = path + ('املاک-' + str_replace(' ', '-', realtor_city_name));
        path = path + ('/مشاورین-املاک');
        path = path + ('/' + str_replace(' ', '-', realtor_district_name));
        path = path + '/u-' + realtor_slug;
        path = path + ('-' + str_replace(' ', '-', name));
        path = path + '-' + str_replace(' ', '-', agency_name);
    }

    return path;
}

/**
 * @param {string} auth_token
 * @param {object} user
 * @param {boolean} storeTokenInCookie
 * */
export function storeUser(auth_token, user, storeTokenInCookie = true) {
    localStorage.setItem('user', JSON.stringify(user));

    if (!isEmpty(auth_token)) {
        localStorage.setItem('auth_token', auth_token);

        if (storeTokenInCookie) {
            saveCookie('auth_token', auth_token);
        }

        const manishen_session = cookie.load('manishen_session');
        if (isEmpty(manishen_session) && process.env.NEXT_PUBLIC_APP_ENV !== 'local') {
            axios.get(process.env.NEXT_PUBLIC_APP_URL + '/setSessionId').then((result) => {
            });
        }
    }
}

/*
* *****************************  API  **********************
* */

/**
 *
 * @return {Promise<User>}
 */
export function getUserInfo() {
    const path = "v1/users/info";

    return new Promise((resolve, reject) => {
        axios.get(path).then(response => {
            resolve(User.make(response.data.user));
        }).catch(error => {
            reject(error);
        });
    });
}

/**
 * @param req
 *
 * @return {Promise<User>}
 */
export function getUserInfoInSSR(req) {
    const path = "v1/users/info";
    let auth_token;
    let fingerprint;

    if (!isEmpty(req) && req.cookies && !isEmpty(req.cookies['auth_token'])) {
        auth_token = req.cookies['auth_token'];
    }

    if (!isEmpty(req) && req.cookies && !isEmpty(req.cookies['fingerprint'])) {
        fingerprint = req.cookies['fingerprint'];
    }

    return new Promise((resolve, reject) => {
        if (!isEmpty(auth_token)) {
            $httpInSSR(auth_token, fingerprint).get(path).then(response => {
                resolve(User.make(response.data.user));
            }).catch(error => {
                reject(error);
            });
        } else {
            resolve(null)
        }
    });
}

/**
 *
 * @return {Promise<User>}
 */
export function getUserPlanInfo() {
    const path = "v1/users/planInfo";

    return new Promise((resolve, reject) => {
        axios.get(path).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
}

/**
 * @param {require|number} realtor_id
 * @param {require|array} reasons => ["knowledge"|"unresponsive"|"commission"|"encounter"]
 * @param {require|number} stars
 * @param {nullable|string} description
 *
 * @return Promise
 * */
export function saveRealtorPoll(realtor_id, reasons, stars, description = null) {
    const path = '/v1/realtors/poll';
    const data = {
        realtor_id: realtor_id,
        reasons: reasons,
        stars: stars,
        description: description
    };

    return new Promise((resolve, reject) => {
        axios.post(path, data).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * @param city_id {number}
 * @param includes_area {Boolean}
 * @param district_id {nullable|Array}
 *
 * @return Promise<Array> => {id, slug, fullName, city_name, district_name, agency_name, avatar}
 * */
export function getProminentRealtors(city_id, includes_area = false, district_id = null) {
    let path = '/search/v1/prominentRealtors?';

    const data = {
        city_id: city_id,
        includes_area: includes_area,
        district_id: district_id
    };

    path = path + httpBuildQuery(data);

    return new Promise((resolve, reject) => {
        axios.get(path).then(result => {
            resolve(result.data);
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param district_id {Number}
 * @param page {Number}
 * @param count {Number}
 *
 * @return Promise
 * */
export function getAllActiveRealtors(district_id, page, count = 24) {
    const data = {district_id, page, count};
    const path = '/search/v1/getAllActiveRealtors?' + httpBuildQuery(data);

    const cacheKey = getCacheKey(cacheTable, 'activeRealtors', 'district-page-count', [district_id, page, count]);
    const cacheTTL = 10 * 60;

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            resolve(result)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param user_id {number|required}
 *
 * @return Promise
 * */
export function realtorContactInfo(user_id) {
    const path = '/v1/realtors/' + user_id + '/contactInfo';

    return new Promise((resolve, reject) => {
        axios.get(path).then(result => {
            resolve(result.data);
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param district_id {Number}
 * @param count {Number|nullable}
 * @param last_week {boolean|nullable}
 *
 * @return Promise <data>
 * */
export function getMostActiveRealtors(district_id, count = 6, last_week = false) {
    let path = '/search/v1/mostActiveRealtors?';

    const data = {
        district_id: district_id,
        count: count,
        last_week: last_week ? 1 : 0
    };

    path = path + httpBuildQuery(data);

    const cacheKey = getCacheKey(cacheTable, 'mostActiveRealtors', 'district-count-last_week', [district_id, count, data["last_week"]]);
    const cacheTTL = 60 * 60; // second

    return new Promise((resolve, reject) => {
        $http(cacheKey, path, cacheTTL).then(result => {
            resolve(result);
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param first_name {string}
 * @param last_name {string}
 * @param academic_degree {string}
 * @param married {boolean}
 * @param education {string}
 * @param born_at {string}
 * @param job {string}
 * @param how_introduce {string}
 * */
export function updateUserInfo({first_name, last_name, academic_degree, married = 0, education, born_at, job, how_introduce}) {
    const path = '/v1/users/update';

    const data = {
        first_name,
        last_name,
        academic_degree,
        married,
        education,
        born_at,
        job,
        how_introduce
    };

    return new Promise((resolve, reject) => {
        axios.post(path, data).then(result => {
            resolve(result.data)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * @param file {string}
 * */
export function storeUserAvatar(file) {
    const path = '/v1/media/user/avatar';

    const data = {file};

    return new Promise((resolve, reject) => {
        axios.post(path, data).then(result => {
            resolve(result.data)
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 *
 * */
export function removeUserAvatar() {
    const path = '/v1/media/user/avatar';

    return new Promise((resolve, reject) => {
        axios.delete(path).then(result => {
            resolve(result.data)
        }).catch(err => {
            reject(err)
        })
    })
}